<template>
    <div style="width: 100%" class="el-table el-table--fit table-trade-card">
        <div id="gradeBox" class="el-table__body-wrapper">
            <table width="98%" border="0" cellpadding="0" cellspacing="0" style="width: 98%; border-collapse: collapse" :style="{ height: height + 'px' }">
                <col width="36" span="2" class="xl65" style="mso-width-source: userset; mso-width-alt: 1152" />
                <col width="39" span="3" class="xl65" style="mso-width-source: userset; mso-width-alt: 1248" />
                <col width="36" span="2" class="xl65" style="mso-width-source: userset; mso-width-alt: 1152" />
                <col width="39" span="3" class="xl65" style="mso-width-source: userset; mso-width-alt: 1248" />
                <col width="36" span="2" class="xl65" style="mso-width-source: userset; mso-width-alt: 1152" />
                <col width="39" span="3" class="xl65" style="mso-width-source: userset; mso-width-alt: 1248" />
                <col width="36" span="2" class="xl65" style="mso-width-source: userset; mso-width-alt: 1152" />
                <col width="39" span="3" class="xl65" style="mso-width-source: userset; mso-width-alt: 1248" />
                <col width="36" span="2" class="xl65" style="mso-width-source: userset; mso-width-alt: 1152" />
                <col width="39" span="3" class="xl65" style="mso-width-source: userset; mso-width-alt: 1248" />
                <col width="36" span="2" class="xl65" style="mso-width-source: userset; mso-width-alt: 1152" />
                <col width="39" span="3" class="xl65" style="mso-width-source: userset; mso-width-alt: 1248" />
                <col width="32" class="xl66" style="mso-width-source: userset; mso-width-alt: 1024" />
                <col width="76" span="3" class="xl65" style="mso-width-source: userset; mso-width-alt: 2432" />
                <col width="99" class="xl65" style="mso-width-source: userset; mso-width-alt: 3168" />
                <col width="72" span="221" class="xl65" style="mso-width-source: userset; mso-width-alt: 2304; display: none" />
                <tr height="30.67" style="height: 23pt; mso-height-source: userset; mso-height-alt: 460">
                    <td class="xl67" height="66.67" width="1493" colspan="35" rowspan="2" style="height: 50pt; width: 1119.75pt; border: none; font-size: 24pt; text-align: center" x:str>学业成绩登记</td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540" />
                <tr height="31.47" style="height: 23.6pt; mso-height-source: userset; mso-height-alt: 472">
                    <td class="xl68" height="31.47" style="height: 23.6pt; border: none"></td>
                    <td class="xl69" colspan="19" style="mso-ignore: colspan; border: none"></td>
                    <td class="xl112" colspan="10" style="mso-ignore: colspan; border: none"></td>
                    <td class="xl115" style="mso-ignore: colspan; border: none"></td>
                    <td class="xl116" colspan="4" style="border: none" x:str>生产实习情况登记</td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl70" height="36" colspan="10" style="height: 27pt; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第一学年</td>
                    <td class="xl70" colspan="10" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第二学年</td>
                    <td class="xl113" colspan="10" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第三学年</td>
                    <td class="xl117" style="border: none"></td>
                    <td class="xl118" x:str>学期</td>
                    <td class="xl155" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>
                        <span style="mso-spacerun: yes">&nbsp;</span>
                        名称
                    </td>
                    <td class="xl108" x:str>成绩</td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl70" height="36" colspan="5" style="height: 27pt; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第一学期</td>
                    <td class="xl70" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第二学期</td>
                    <td class="xl70" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第三学期</td>
                    <td class="xl70" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第四学期</td>
                    <td class="xl70" colspan="5" style="border-right: none; border-bottom: 0.5pt solid #000000" x:str>第五学期</td>
                    <td class="xl70" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>第六学期</td>
                    <td class="xl120" style="border: none"></td>
                    <td class="xl121">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[0].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[0].internshipNum || '' }}</span>
                    </td>
                    <td class="xl157" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[0].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[0].internshipName || '' }}</span>
                    </td>
                    <td class="xl72">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[0].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[0].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl73" height="144" colspan="2" rowspan="4" style="height: 108pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>科目</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期中考</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期终考</td>
                    <td class="xl76" rowspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>总评</td>
                    <td class="xl73" colspan="2" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>科目</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期中考</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期终考</td>
                    <td class="xl76" rowspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>总评</td>
                    <td class="xl73" colspan="2" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>科目</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期中考</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期终考</td>
                    <td class="xl76" rowspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>总评</td>
                    <td class="xl73" colspan="2" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>科目</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期中考</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期终考</td>
                    <td class="xl76" rowspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>总评</td>
                    <td class="xl73" colspan="2" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>科目</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期中考</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期终考</td>
                    <td class="xl122" rowspan="4" style="border-right: none; border-bottom: 0.5pt solid #000000" x:str>总评</td>
                    <td class="xl73" colspan="2" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>科目</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期中考</td>
                    <td class="xl75" rowspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>期终考</td>
                    <td class="xl76" rowspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>总评</td>
                    <td class="xl123" style="border: none"></td>
                    <td class="xl121">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[1].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[1].internshipNum || '' }}</span>
                    </td>
                    <td class="xl157" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[1].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[1].internshipName || '' }}</span>
                    </td>
                    <td class="xl72">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[1].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[1].internshipScore || '' }}</span>
                    </td>
                </tr>
                <!-- <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl125" style="border: none"></td>
                    <td class="xl121">
                        <el-input v-if="canEdit" v-model="internshipSituations[2].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ internshipSituations[2].internshipNum || '' }}</span>
                    </td>
                    <td class="xl157" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="internshipSituations[2].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ internshipSituations[2].internshipName || '' }}</span>
                    </td>
                    <td class="xl72">
                        <el-input v-if="canEdit" v-model="internshipSituations[2].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ internshipSituations[2].internshipScore || '' }}</span>
                    </td>
                </tr> -->
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl125" style="border: none"></td>
                    <td class="xl121">
                        <span>{{ internshipSituations[2].internshipNum || '' }}</span>
                    </td>
                    <td class="xl157" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <span>{{ internshipSituations[2].internshipName || '' }}</span>
                    </td>
                    <td class="xl72">
                        <span>{{ internshipSituations[2].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl125" style="border: none"></td>
                    <td class="xl121">
                        <span>{{ internshipSituations[3].internshipNum || '' }}</span>
                    </td>
                    <td class="xl157" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <span>{{ internshipSituations[3].internshipName || '' }}</span>
                    </td>
                    <td class="xl72">
                        <span>{{ internshipSituations[3].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl125" style="border: none"></td>
                    <td class="xl121">
                        <span>{{ internshipSituations[4].internshipNum || '' }}</span>
                    </td>
                    <td class="xl157" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <span>{{ internshipSituations[4].internshipName || '' }}</span>
                    </td>
                    <td class="xl72">
                        <span>{{ internshipSituations[4].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[0] && scoresList[0][0]">
                            <span>{{ scoresList[0][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][0]">
                            <el-input v-if="canEdit && scoresList[0][0].courseName" v-model="scoresList[0][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][0]">
                            <el-input v-if="canEdit && scoresList[0][0].courseName" v-model="scoresList[0][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][0]">
                            <span>{{ scoresList[0][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[0] && scoresList[0][1]">
                            <span>{{ scoresList[0][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][1]">
                            <el-input v-if="canEdit && scoresList[0][1].courseName" v-model="scoresList[0][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][1]">
                            <el-input v-if="canEdit && scoresList[0][1].courseName" v-model="scoresList[0][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][1]">
                            <span>{{ scoresList[0][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[0] && scoresList[0][2]">
                            <span>{{ scoresList[0][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][2]">
                            <el-input v-if="canEdit && scoresList[0][2].courseName" v-model="scoresList[0][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][2]">
                            <el-input v-if="canEdit && scoresList[0][2].courseName" v-model="scoresList[0][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][2]">
                            <span>{{ scoresList[0][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[0] && scoresList[0][3]">
                            <span>{{ scoresList[0][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][3]">
                            <el-input v-if="canEdit && scoresList[0][3].courseName" v-model="scoresList[0][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][3]">
                            <el-input v-if="canEdit && scoresList[0][3].courseName" v-model="scoresList[0][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][3]">
                            <span>{{ scoresList[0][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[0] && scoresList[0][4]">
                            <span>{{ scoresList[0][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][4]">
                            <el-input v-if="canEdit && scoresList[0][4].courseName" v-model="scoresList[0][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][4]">
                            <el-input v-if="canEdit && scoresList[0][4].courseName" v-model="scoresList[0][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][4]">
                            <span>{{ scoresList[0][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[0] && scoresList[0][5]">
                            <span>{{ scoresList[0][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][5]">
                            <el-input v-if="canEdit && scoresList[0][5].courseName" v-model="scoresList[0][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][5]">
                            <el-input v-if="canEdit && scoresList[0][5].courseName" v-model="scoresList[0][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[0][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[0] && scoresList[0][5]">
                            <span>{{ scoresList[0][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl131" style="border: none"></td>
                    <td class="xl132">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[5].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[5].internshipNum || '' }}</span>
                    </td>
                    <td class="xl158" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[5].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[5].internshipName || '' }}</span>
                    </td>
                    <td class="xl160">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[5].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[5].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[1] && scoresList[1][0]">
                            <span>{{ scoresList[1][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][0]">
                            <el-input v-if="canEdit && scoresList[1][0].courseName" v-model="scoresList[1][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][0]">
                            <el-input v-if="canEdit && scoresList[1][0].courseName" v-model="scoresList[1][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][0]">
                            <span>{{ scoresList[1][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[1] && scoresList[1][1]">
                            <span>{{ scoresList[1][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][1]">
                            <el-input v-if="canEdit && scoresList[1][1].courseName" v-model="scoresList[1][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][1]">
                            <el-input v-if="canEdit && scoresList[1][1].courseName" v-model="scoresList[1][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][1]">
                            <span>{{ scoresList[1][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[1] && scoresList[1][2]">
                            <span>{{ scoresList[1][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][2]">
                            <el-input v-if="canEdit && scoresList[1][2].courseName" v-model="scoresList[1][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][2]">
                            <el-input v-if="canEdit && scoresList[1][2].courseName" v-model="scoresList[1][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][2]">
                            <span>{{ scoresList[1][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[1] && scoresList[1][3]">
                            <span>{{ scoresList[1][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][3]">
                            <el-input v-if="canEdit && scoresList[1][3].courseName" v-model="scoresList[1][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][3]">
                            <el-input v-if="canEdit && scoresList[1][3].courseName" v-model="scoresList[1][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][3]">
                            <span>{{ scoresList[1][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[1] && scoresList[1][4]">
                            <span>{{ scoresList[1][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][4]">
                            <el-input v-if="canEdit && scoresList[1][4].courseName" v-model="scoresList[1][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][4]">
                            <el-input v-if="canEdit && scoresList[1][4].courseName" v-model="scoresList[1][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][4]">
                            <span>{{ scoresList[1][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[1] && scoresList[1][5]">
                            <span>{{ scoresList[1][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][5]">
                            <el-input v-if="canEdit && scoresList[1][5].courseName" v-model="scoresList[1][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][5]">
                            <el-input v-if="canEdit && scoresList[1][5].courseName" v-model="scoresList[1][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[1][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[1] && scoresList[1][5]">
                            <span>{{ scoresList[1][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl135" style="border: none"></td>
                    <td class="xl132">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[6].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[6].internshipNum || '' }}</span>
                    </td>
                    <td class="xl158" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[6].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[6].internshipName || '' }}</span>
                    </td>
                    <td class="xl160">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[6].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[6].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[2] && scoresList[2][0]">
                            <span>{{ scoresList[2][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][0]">
                            <el-input v-if="canEdit && scoresList[2][0].courseName" v-model="scoresList[2][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][0]">
                            <el-input v-if="canEdit && scoresList[2][0].courseName" v-model="scoresList[2][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][0]">
                            <span>{{ scoresList[2][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[2] && scoresList[2][1]">
                            <span>{{ scoresList[2][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][1]">
                            <el-input v-if="canEdit && scoresList[2][1].courseName" v-model="scoresList[2][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][1]">
                            <el-input v-if="canEdit && scoresList[2][1].courseName" v-model="scoresList[2][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][1]">
                            <span>{{ scoresList[2][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[2] && scoresList[2][2]">
                            <span>{{ scoresList[2][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][2]">
                            <el-input v-if="canEdit && scoresList[2][2].courseName" v-model="scoresList[2][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][2]">
                            <el-input v-if="canEdit && scoresList[2][2].courseName" v-model="scoresList[2][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][2]">
                            <span>{{ scoresList[2][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[2] && scoresList[2][3]">
                            <span>{{ scoresList[2][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][3]">
                            <el-input v-if="canEdit && scoresList[2][3].courseName" v-model="scoresList[2][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][3]">
                            <el-input v-if="canEdit && scoresList[2][3].courseName" v-model="scoresList[2][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][3]">
                            <span>{{ scoresList[2][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[2] && scoresList[2][4]">
                            <span>{{ scoresList[2][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][4]">
                            <el-input v-if="canEdit && scoresList[2][4].courseName" v-model="scoresList[2][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][4]">
                            <el-input v-if="canEdit && scoresList[2][4].courseName" v-model="scoresList[2][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][4]">
                            <span>{{ scoresList[2][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[2] && scoresList[2][5]">
                            <span>{{ scoresList[2][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][5]">
                            <el-input v-if="canEdit && scoresList[2][5].courseName" v-model="scoresList[2][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][5]">
                            <el-input v-if="canEdit && scoresList[2][5].courseName" v-model="scoresList[2][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[2][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[2] && scoresList[2][5]">
                            <span>{{ scoresList[2][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl136" style="border: none"></td>
                    <td class="xl137">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[7].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[7].internshipNum || '' }}</span>
                    </td>
                    <td class="xl158" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[7].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[7].internshipName || '' }}</span>
                    </td>
                    <td class="xl130">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[7].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[7].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[3] && scoresList[3][0]">
                            <span>{{ scoresList[3][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][0]">
                            <el-input v-if="canEdit && scoresList[3][0].courseName" v-model="scoresList[3][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][0]">
                            <el-input v-if="canEdit && scoresList[3][0].courseName" v-model="scoresList[3][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][0]">
                            <span>{{ scoresList[3][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[3] && scoresList[3][1]">
                            <span>{{ scoresList[3][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][1]">
                            <el-input v-if="canEdit && scoresList[3][1].courseName" v-model="scoresList[3][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][1]">
                            <el-input v-if="canEdit && scoresList[3][1].courseName" v-model="scoresList[3][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][1]">
                            <span>{{ scoresList[3][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[3] && scoresList[3][2]">
                            <span>{{ scoresList[3][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][2]">
                            <el-input v-if="canEdit && scoresList[3][2].courseName" v-model="scoresList[3][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][2]">
                            <el-input v-if="canEdit && scoresList[3][2].courseName" v-model="scoresList[3][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][2]">
                            <span>{{ scoresList[3][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[3] && scoresList[3][3]">
                            <span>{{ scoresList[3][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][3]">
                            <el-input v-if="canEdit && scoresList[3][3].courseName" v-model="scoresList[3][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][3]">
                            <el-input v-if="canEdit && scoresList[3][3].courseName" v-model="scoresList[3][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][3]">
                            <span>{{ scoresList[3][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[3] && scoresList[3][4]">
                            <span>{{ scoresList[3][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][4]">
                            <el-input v-if="canEdit && scoresList[3][4].courseName" v-model="scoresList[3][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][4]">
                            <el-input v-if="canEdit && scoresList[3][4].courseName" v-model="scoresList[3][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][4]">
                            <span>{{ scoresList[3][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[3] && scoresList[3][5]">
                            <span>{{ scoresList[3][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][5]">
                            <el-input v-if="canEdit && scoresList[3][5].courseName" v-model="scoresList[3][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][5]">
                            <el-input v-if="canEdit && scoresList[3][5].courseName" v-model="scoresList[3][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[3][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[3] && scoresList[3][5]">
                            <span>{{ scoresList[3][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl138" style="border: none"></td>
                    <td class="xl139">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[8].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[8].internshipNum || '' }}</span>
                    </td>
                    <td class="xl158" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[8].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[8].internshipName || '' }}</span>
                    </td>
                    <td class="xl161">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[8].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[8].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[4] && scoresList[4][0]">
                            <span>{{ scoresList[4][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][0]">
                            <el-input v-if="canEdit && scoresList[4][0].courseName" v-model="scoresList[4][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][0]">
                            <el-input v-if="canEdit && scoresList[4][0].courseName" v-model="scoresList[4][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][0]">
                            <span>{{ scoresList[4][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[4] && scoresList[4][1]">
                            <span>{{ scoresList[4][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][1]">
                            <el-input v-if="canEdit && scoresList[4][1].courseName" v-model="scoresList[4][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][1]">
                            <el-input v-if="canEdit && scoresList[4][1].courseName" v-model="scoresList[4][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][1]">
                            <span>{{ scoresList[4][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[4] && scoresList[4][2]">
                            <span>{{ scoresList[4][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][2]">
                            <el-input v-if="canEdit && scoresList[4][2].courseName" v-model="scoresList[4][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][2]">
                            <el-input v-if="canEdit && scoresList[4][2].courseName" v-model="scoresList[4][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][2]">
                            <span>{{ scoresList[4][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[4] && scoresList[4][3]">
                            <span>{{ scoresList[4][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][3]">
                            <el-input v-if="canEdit && scoresList[4][3].courseName" v-model="scoresList[4][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][3]">
                            <el-input v-if="canEdit && scoresList[4][3].courseName" v-model="scoresList[4][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][3]">
                            <span>{{ scoresList[4][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[4] && scoresList[4][4]">
                            <span>{{ scoresList[4][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][4]">
                            <el-input v-if="canEdit && scoresList[4][4].courseName" v-model="scoresList[4][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][4]">
                            <el-input v-if="canEdit && scoresList[4][4].courseName" v-model="scoresList[4][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][4]">
                            <span>{{ scoresList[4][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[4] && scoresList[4][5]">
                            <span>{{ scoresList[4][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][5]">
                            <el-input v-if="canEdit && scoresList[4][5].courseName" v-model="scoresList[4][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][5]">
                            <el-input v-if="canEdit && scoresList[4][5].courseName" v-model="scoresList[4][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[4][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[4] && scoresList[4][5]">
                            <span>{{ scoresList[4][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl138" style="border: none"></td>
                    <td class="xl139">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[9].internshipNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[9].internshipNum || '' }}</span>
                    </td>
                    <td class="xl158" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[9].internshipName" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[9].internshipName || '' }}</span>
                    </td>
                    <td class="xl161">
                        <!-- <el-input v-if="canEdit" v-model="internshipSituations[9].internshipScore" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ internshipSituations[9].internshipScore || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[5] && scoresList[5][0]">
                            <span>{{ scoresList[5][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][0]">
                            <el-input v-if="canEdit && scoresList[5][0].courseName" v-model="scoresList[5][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][0]">
                            <el-input v-if="canEdit && scoresList[5][0].courseName" v-model="scoresList[5][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][0]">
                            <span>{{ scoresList[5][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[5] && scoresList[5][1]">
                            <span>{{ scoresList[5][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][1]">
                            <el-input v-if="canEdit && scoresList[5][1].courseName" v-model="scoresList[5][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][1]">
                            <el-input v-if="canEdit && scoresList[5][1].courseName" v-model="scoresList[5][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][1]">
                            <span>{{ scoresList[5][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[5] && scoresList[5][2]">
                            <span>{{ scoresList[5][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][2]">
                            <el-input v-if="canEdit && scoresList[5][2].courseName" v-model="scoresList[5][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][2]">
                            <el-input v-if="canEdit && scoresList[5][2].courseName" v-model="scoresList[5][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][2]">
                            <span>{{ scoresList[5][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[5] && scoresList[5][3]">
                            <span>{{ scoresList[5][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][3]">
                            <el-input v-if="canEdit && scoresList[5][3].courseName" v-model="scoresList[5][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][3]">
                            <el-input v-if="canEdit && scoresList[5][3].courseName" v-model="scoresList[5][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][3]">
                            <span>{{ scoresList[5][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[5] && scoresList[5][4]">
                            <span>{{ scoresList[5][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][4]">
                            <el-input v-if="canEdit && scoresList[5][4].courseName" v-model="scoresList[5][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][4]">
                            <el-input v-if="canEdit && scoresList[5][4].courseName" v-model="scoresList[5][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][4]">
                            <span>{{ scoresList[5][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[5] && scoresList[5][5]">
                            <span>{{ scoresList[5][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][5]">
                            <el-input v-if="canEdit && scoresList[5][5].courseName" v-model="scoresList[5][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][5]">
                            <el-input v-if="canEdit && scoresList[5][5].courseName" v-model="scoresList[5][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[5][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[5] && scoresList[5][5]">
                            <span>{{ scoresList[5][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl140" style="border: none"></td>
                    <td class="xl141"></td>
                    <td class="xl140" colspan="2" style="mso-ignore: colspan"></td>
                    <td class="xl162"></td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[6] && scoresList[6][0]">
                            <span>{{ scoresList[6][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][0]">
                            <el-input v-if="canEdit && scoresList[6][0].courseName" v-model="scoresList[6][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][0]">
                            <el-input v-if="canEdit && scoresList[6][0].courseName" v-model="scoresList[6][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][0]">
                            <span>{{ scoresList[6][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[6] && scoresList[6][1]">
                            <span>{{ scoresList[6][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][1]">
                            <el-input v-if="canEdit && scoresList[6][1].courseName" v-model="scoresList[6][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][1]">
                            <el-input v-if="canEdit && scoresList[6][1].courseName" v-model="scoresList[6][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][1]">
                            <span>{{ scoresList[6][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[6] && scoresList[6][2]">
                            <span>{{ scoresList[6][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][2]">
                            <el-input v-if="canEdit && scoresList[6][2].courseName" v-model="scoresList[6][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][2]">
                            <el-input v-if="canEdit && scoresList[6][2].courseName" v-model="scoresList[6][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][2]">
                            <span>{{ scoresList[6][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[6] && scoresList[6][3]">
                            <span>{{ scoresList[6][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][3]">
                            <el-input v-if="canEdit && scoresList[6][3].courseName" v-model="scoresList[6][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][3]">
                            <el-input v-if="canEdit && scoresList[6][3].courseName" v-model="scoresList[6][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][3]">
                            <span>{{ scoresList[6][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[6] && scoresList[6][4]">
                            <span>{{ scoresList[6][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][4]">
                            <el-input v-if="canEdit && scoresList[6][4].courseName" v-model="scoresList[6][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][4]">
                            <el-input v-if="canEdit && scoresList[6][4].courseName" v-model="scoresList[6][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][4]">
                            <span>{{ scoresList[6][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[6] && scoresList[6][5]">
                            <span>{{ scoresList[6][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][5]">
                            <el-input v-if="canEdit && scoresList[6][5].courseName" v-model="scoresList[6][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][5]">
                            <el-input v-if="canEdit && scoresList[6][5].courseName" v-model="scoresList[6][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[6][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[6] && scoresList[6][5]">
                            <span>{{ scoresList[6][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl140" style="border: none"></td>
                    <td class="xl116" colspan="4" style="border: none" x:str>休、退、转、复学记录</td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[7] && scoresList[7][0]">
                            <span>{{ scoresList[7][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][0]">
                            <el-input v-if="canEdit && scoresList[7][0].courseName" v-model="scoresList[7][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][0]">
                            <el-input v-if="canEdit && scoresList[7][0].courseName" v-model="scoresList[7][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][0]">
                            <span>{{ scoresList[7][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[7] && scoresList[7][1]">
                            <span>{{ scoresList[7][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][1]">
                            <el-input v-if="canEdit && scoresList[7][1].courseName" v-model="scoresList[7][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][1]">
                            <el-input v-if="canEdit && scoresList[7][1].courseName" v-model="scoresList[7][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][1]">
                            <span>{{ scoresList[7][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[7] && scoresList[7][2]">
                            <span>{{ scoresList[7][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][2]">
                            <el-input v-if="canEdit && scoresList[7][2].courseName" v-model="scoresList[7][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][2]">
                            <el-input v-if="canEdit && scoresList[7][2].courseName" v-model="scoresList[7][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][2]">
                            <span>{{ scoresList[7][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[7] && scoresList[7][3]">
                            <span>{{ scoresList[7][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][3]">
                            <el-input v-if="canEdit && scoresList[7][3].courseName" v-model="scoresList[7][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][3]">
                            <el-input v-if="canEdit && scoresList[7][3].courseName" v-model="scoresList[7][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][3]">
                            <span>{{ scoresList[7][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[7] && scoresList[7][4]">
                            <span>{{ scoresList[7][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][4]">
                            <el-input v-if="canEdit && scoresList[7][4].courseName" v-model="scoresList[7][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][4]">
                            <el-input v-if="canEdit && scoresList[7][4].courseName" v-model="scoresList[7][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][4]">
                            <span>{{ scoresList[7][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[7] && scoresList[7][5]">
                            <span>{{ scoresList[7][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][5]">
                            <el-input v-if="canEdit && scoresList[7][5].courseName" v-model="scoresList[7][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][5]">
                            <el-input v-if="canEdit && scoresList[7][5].courseName" v-model="scoresList[7][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[7][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[7] && scoresList[7][5]">
                            <span>{{ scoresList[7][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl135" style="border: none"></td>
                    <td class="xl118" x:str>时间</td>
                    <td class="xl155" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000" x:str>原因及处理结果</td>
                    <td class="xl108" x:str>发证字号</td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[8] && scoresList[8][0]">
                            <span>{{ scoresList[8][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][0]">
                            <el-input v-if="canEdit && scoresList[8][0].courseName" v-model="scoresList[8][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][0]">
                            <el-input v-if="canEdit && scoresList[8][0].courseName" v-model="scoresList[8][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][0]">
                            <span>{{ scoresList[8][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[8] && scoresList[8][1]">
                            <span>{{ scoresList[8][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][1]">
                            <el-input v-if="canEdit && scoresList[8][1].courseName" v-model="scoresList[8][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][1]">
                            <el-input v-if="canEdit && scoresList[8][1].courseName" v-model="scoresList[8][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][1]">
                            <span>{{ scoresList[8][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[8] && scoresList[8][2]">
                            <span>{{ scoresList[8][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][2]">
                            <el-input v-if="canEdit && scoresList[8][2].courseName" v-model="scoresList[8][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][2]">
                            <el-input v-if="canEdit && scoresList[8][2].courseName" v-model="scoresList[8][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][2]">
                            <span>{{ scoresList[8][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[8] && scoresList[8][3]">
                            <span>{{ scoresList[8][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][3]">
                            <el-input v-if="canEdit && scoresList[8][3].courseName" v-model="scoresList[8][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][3]">
                            <el-input v-if="canEdit && scoresList[8][3].courseName" v-model="scoresList[8][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][3]">
                            <span>{{ scoresList[8][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[8] && scoresList[8][4]">
                            <span>{{ scoresList[8][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][4]">
                            <el-input v-if="canEdit && scoresList[8][4].courseName" v-model="scoresList[8][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][4]">
                            <el-input v-if="canEdit && scoresList[8][4].courseName" v-model="scoresList[8][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][4]">
                            <span>{{ scoresList[8][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[8] && scoresList[8][5]">
                            <span>{{ scoresList[8][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][5]">
                            <el-input v-if="canEdit && scoresList[8][5].courseName" v-model="scoresList[8][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][5]">
                            <el-input v-if="canEdit && scoresList[8][5].courseName" v-model="scoresList[8][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[8][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[8] && scoresList[8][5]">
                            <span>{{ scoresList[8][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl136" style="border: none"></td>
                    <td class="xl137" rowspan="3" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="otherSituations.otherTime" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ otherSituations.otherTime || '' }}</span>
                    </td>
                    <td class="xl163" colspan="2" rowspan="3" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="otherSituations.otherResult" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ otherSituations.otherResult || '' }}</span>
                    </td>
                    <td class="xl130" rowspan="3" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="otherSituations.otherNum" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ otherSituations.otherNum || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[9] && scoresList[9][0]">
                            <span>{{ scoresList[9][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][0]">
                            <el-input v-if="canEdit && scoresList[9][0].courseName" v-model="scoresList[9][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][0]">
                            <el-input v-if="canEdit && scoresList[9][0].courseName" v-model="scoresList[9][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][0]">
                            <span>{{ scoresList[9][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[9] && scoresList[9][1]">
                            <span>{{ scoresList[9][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][1]">
                            <el-input v-if="canEdit && scoresList[9][1].courseName" v-model="scoresList[9][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][1]">
                            <el-input v-if="canEdit && scoresList[9][1].courseName" v-model="scoresList[9][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][1]">
                            <span>{{ scoresList[9][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[9] && scoresList[9][2]">
                            <span>{{ scoresList[9][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][2]">
                            <el-input v-if="canEdit && scoresList[9][2].courseName" v-model="scoresList[9][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][2]">
                            <el-input v-if="canEdit && scoresList[9][2].courseName" v-model="scoresList[9][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][2]">
                            <span>{{ scoresList[9][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[9] && scoresList[9][3]">
                            <span>{{ scoresList[9][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][3]">
                            <el-input v-if="canEdit && scoresList[9][3].courseName" v-model="scoresList[9][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][3]">
                            <el-input v-if="canEdit && scoresList[9][3].courseName" v-model="scoresList[9][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][3]">
                            <span>{{ scoresList[9][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[9] && scoresList[9][4]">
                            <span>{{ scoresList[9][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][4]">
                            <el-input v-if="canEdit && scoresList[9][4].courseName" v-model="scoresList[9][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][4]">
                            <el-input v-if="canEdit && scoresList[9][4].courseName" v-model="scoresList[9][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][4]">
                            <span>{{ scoresList[9][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[9] && scoresList[9][5]">
                            <span>{{ scoresList[9][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][5]">
                            <el-input v-if="canEdit && scoresList[9][5].courseName" v-model="scoresList[9][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][5]">
                            <el-input v-if="canEdit && scoresList[9][5].courseName" v-model="scoresList[9][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[9][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[9] && scoresList[9][5]">
                            <span>{{ scoresList[9][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl144" style="border: none"></td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[10] && scoresList[10][0]">
                            <span>{{ scoresList[10][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][0]">
                            <el-input v-if="canEdit && scoresList[10][0].courseName" v-model="scoresList[10][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][0]">
                            <el-input v-if="canEdit && scoresList[10][0].courseName" v-model="scoresList[10][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][0]">
                            <span>{{ scoresList[10][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[10] && scoresList[10][1]">
                            <span>{{ scoresList[10][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][1]">
                            <el-input v-if="canEdit && scoresList[10][1].courseName" v-model="scoresList[10][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][1]">
                            <el-input v-if="canEdit && scoresList[10][1].courseName" v-model="scoresList[10][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][1]">
                            <span>{{ scoresList[10][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[10] && scoresList[10][2]">
                            <span>{{ scoresList[10][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][2]">
                            <el-input v-if="canEdit && scoresList[10][2].courseName" v-model="scoresList[10][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][2]">
                            <el-input v-if="canEdit && scoresList[10][2].courseName" v-model="scoresList[10][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][2]">
                            <span>{{ scoresList[10][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[10] && scoresList[10][3]">
                            <span>{{ scoresList[10][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][3]">
                            <el-input v-if="canEdit && scoresList[10][3].courseName" v-model="scoresList[10][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][3]">
                            <el-input v-if="canEdit && scoresList[10][3].courseName" v-model="scoresList[10][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][3]">
                            <span>{{ scoresList[10][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[10] && scoresList[10][4]">
                            <span>{{ scoresList[10][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][4]">
                            <el-input v-if="canEdit && scoresList[10][4].courseName" v-model="scoresList[10][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][4]">
                            <el-input v-if="canEdit && scoresList[10][4].courseName" v-model="scoresList[10][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][4]">
                            <span>{{ scoresList[10][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[10] && scoresList[10][5]">
                            <span>{{ scoresList[10][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][5]">
                            <el-input v-if="canEdit && scoresList[10][5].courseName" v-model="scoresList[10][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][5]">
                            <el-input v-if="canEdit && scoresList[10][5].courseName" v-model="scoresList[10][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[10][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[10] && scoresList[10][5]">
                            <span>{{ scoresList[10][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl138" style="border: none"></td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl88" height="36" colspan="2" style="height: 27pt; border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[11] && scoresList[11][0]">
                            <span>{{ scoresList[11][0].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][0]">
                            <el-input v-if="canEdit && scoresList[11][0].courseName" v-model="scoresList[11][0].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][0].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][0]">
                            <el-input v-if="canEdit && scoresList[11][0].courseName" v-model="scoresList[11][0].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][0].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][0]">
                            <span>{{ scoresList[11][0].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[11] && scoresList[11][1]">
                            <span>{{ scoresList[11][1].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][1]">
                            <el-input v-if="canEdit && scoresList[11][1].courseName" v-model="scoresList[11][1].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][1].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][1]">
                            <el-input v-if="canEdit && scoresList[11][1].courseName" v-model="scoresList[11][1].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][1].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][1]">
                            <span>{{ scoresList[11][1].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[11] && scoresList[11][2]">
                            <span>{{ scoresList[11][2].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][2]">
                            <el-input v-if="canEdit && scoresList[11][2].courseName" v-model="scoresList[11][2].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][2].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][2]">
                            <el-input v-if="canEdit && scoresList[11][2].courseName" v-model="scoresList[11][2].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][2].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][2]">
                            <span>{{ scoresList[11][2].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[11] && scoresList[11][3]">
                            <span>{{ scoresList[11][3].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][3]">
                            <el-input v-if="canEdit && scoresList[11][3].courseName" v-model="scoresList[11][3].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][3].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][3]">
                            <el-input v-if="canEdit && scoresList[11][3].courseName" v-model="scoresList[11][3].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][3].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][3]">
                            <span>{{ scoresList[11][3].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[11] && scoresList[11][4]">
                            <span>{{ scoresList[11][4].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][4]">
                            <el-input v-if="canEdit && scoresList[11][4].courseName" v-model="scoresList[11][4].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][4].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][4]">
                            <el-input v-if="canEdit && scoresList[11][4].courseName" v-model="scoresList[11][4].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][4].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][4]">
                            <span>{{ scoresList[11][4].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl88" colspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid windowtext">
                        <template v-if="scoresList[11] && scoresList[11][5]">
                            <span>{{ scoresList[11][5].courseName || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][5]">
                            <el-input v-if="canEdit && scoresList[11][5].courseName" v-model="scoresList[11][5].midScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][5].midScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][5]">
                            <el-input v-if="canEdit && scoresList[11][5].courseName" v-model="scoresList[11][5].endScore" size="mini" class="stu_card_input" resize="none" placeholder=""></el-input>
                            <span v-else>{{ scoresList[11][5].endScore || '' }}</span>
                        </template>
                    </td>
                    <td class="xl90">
                        <template v-if="scoresList[11] && scoresList[11][5]">
                            <span>{{ scoresList[11][5].score || '' }}</span>
                        </template>
                    </td>
                    <td class="xl140" style="border: none"></td>
                    <td class="xl147" colspan="4" style="mso-ignore: colspan; border: none"></td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl98" height="144" rowspan="4" style="height: 108pt; border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>考勤情况</td>
                    <td class="xl99" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid windowtext" x:str>事假（时数）</td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[0].field1" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[0].field1 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[0].field2" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[0].field2 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[0].field3" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[0].field3 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[0].field4" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[0].field4 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[0].field5" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[0].field5 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[0].field6" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[0].field6 || '' }}</span>
                    </td>
                    <td class="xl140" style="border: none"></td>
                    <td class="xl116" colspan="4" style="border: none" x:str>毕业情况</td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl99" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid windowtext" x:str>病假（时数）</td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[1].field1" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[1].field1 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[1].field2" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[1].field2 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[1].field3" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[1].field3 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[1].field4" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[1].field4 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[1].field5" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[1].field5 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[1].field6" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[1].field6 || '' }}</span>
                    </td>
                    <td class="xl148" style="border: none"></td>
                    <td class="xl149" x:str>毕业时间</td>
                    <td class="xl169">
                        <el-input v-if="canEdit" v-model="graduateSituations.field7" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ graduateSituations.field7 || '' }}</span>
                    </td>
                    <td class="xl170" x:str>毕业证编号</td>
                    <td class="xl171">
                        <el-input v-if="canEdit" v-model="graduateSituations.field8" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ graduateSituations.field8 || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl99" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid windowtext" x:str>旷课（时数）</td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[2].field1" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[2].field1 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[2].field2" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[2].field2 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[2].field3" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[2].field3 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[2].field4" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[2].field4 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[2].field5" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[2].field5 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[2].field6" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[2].field6 || '' }}</span>
                    </td>
                    <td class="xl150" style="border: none"></td>
                    <td class="xl151" x:str>毕业后</td>
                    <td class="xl172" rowspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="graduateSituations.field9" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ graduateSituations.field9 || '' }}</span>
                    </td>
                    <td class="xl172" rowspan="2" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="graduateSituations.field10" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ graduateSituations.field10 || '' }}</span>
                    </td>
                    <td class="xl173" rowspan="2" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <el-input v-if="canEdit" v-model="graduateSituations.field11" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input>
                        <span v-else>{{ graduateSituations.field11 || '' }}</span>
                    </td>
                </tr>
                <tr height="36" style="height: 27pt; mso-height-source: userset; mso-height-alt: 540">
                    <td class="xl105" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000" x:str>缺课时数总计</td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[3].field1" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[3].field1 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="4" style="border-right: 0.5pt solid windowtext; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[3].field2" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[3].field2 || '' }}</span>
                    </td>
                    <td class="xl111" colspan="5" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[3].field3" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[3].field3 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[3].field4" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[3].field4 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[3].field5" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[3].field5 || '' }}</span>
                    </td>
                    <td class="xl102" colspan="4" style="border-right: 0.5pt solid #000000; border-bottom: 0.5pt solid #000000">
                        <!-- <el-input v-if="canEdit" v-model="attendanceSituations[3].field6" size="mini" class="stu_card_input" resize="none" placeholder="请输入"></el-input> -->
                        <span>{{ attendanceSituations[3].field6 || '' }}</span>
                    </td>
                    <td class="xl152" style="border: none"></td>
                    <td class="xl153" x:str>的去向</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { initCourseCardData } from './help'
export default {
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: {
            type: Number,
            default: 1
        },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data: function () {
        return {
            height: 900,
            // semesterList: [],
            // timecardList: [],
            // otherSituationsList: [],
            // otherSituationsObj: {},
            scoresList: [], // 学期成绩
            internshipSituations: [], // 生产实习情况
            otherSituations: [], // 休、退、转、复学记录
            attendanceSituations: [], // 考勤情况
            graduateSituations: [] // 毕业情况
        }
    },
    computed: {},
    watch: {
        vo: function (val) {
            this.initData()
        }
    },
    created: function () {
        this.initData()
    },
    beforeDestroy: function () {},
    mounted: function () {
        // let _basicBox = document.getElementById('basicBox')
        // this.height = _basicBox.offsetHeight
    },
    methods: {
        initData() {
            const { internshipSituations, otherSituations, attendanceSituations, graduateSituations, passenger } = this.vo
            if (internshipSituations === null) {
                this.internshipSituations = initCourseCardData().otherSituationsList
            } else {
                this.internshipSituations = JSON.parse(internshipSituations)
            }
            if (otherSituations === null) {
                this.otherSituations = Object.assign({}, initCourseCardData().otherSituationsObj)
            } else {
                this.otherSituations = JSON.parse(otherSituations)
            }
            if (attendanceSituations === null) {
                this.attendanceSituations = initCourseCardData().timecardList
            } else {
                this.attendanceSituations = JSON.parse(attendanceSituations)
            }
            if (graduateSituations === null) {
                this.graduateSituations = Object.assign({}, initCourseCardData().otherSituationsObj)
            } else {
                this.graduateSituations = JSON.parse(graduateSituations)
            }
            this.scoresList = this.processScoreList(passenger.scoresList)
            // this.semesterList = initCourseCardData().semesterList
            // this.timecardList = initCourseCardData().timecardList
            // this.otherSituationsList = initCourseCardData().otherSituationsList
            // this.otherSituationsObj = initCourseCardData().otherSituationsObj

            // this.$set(this.vo.passenger, 'timecardList', this.timecardList) // 基础信息
            // this.$set(this.vo.passenger, 'semesterList', this.semesterList) // 基础信息
            // this.$set(this.vo.passenger, 'otherSituationsList', this.otherSituationsList) // 基础信息
            // this.$set(this.vo.passenger, 'otherSituationsObj', this.otherSituationsObj) // 基础信息
            // console.log('this.vo', this.vo)
        },
        processScoreList(val) { // val长度6，子数组长度12
            if (!Array.isArray(val) || val.length === 0) {
                return []
            }
            const result = Array.from({ length: 12 }, () => []) // arr长度12,子数组长度6
            for (let i = 0; i < val.length; i++) {
                if (!val[i]) continue

                for (let j = 0; j < val[i].length; j++) {
                    if (val[i][j] !== undefined && val[i][j] !== null && j < 12) {
                        result[j][i] = val[i][j]
                    }
                }
            }

            return result
        }
    }
}
</script>
<style scoped lang="scss">
.table-trade-card::before {
    background-color: transparent !important;
}

#gradeBox {
    .stu_card_input {
        width: 100%;
        padding: 0 3px;

        /deep/.el-input__inner {
            height: 32px;
            line-height: 32px;
            border: none;
            border-bottom: 1px solid #ccc;
            border-radius: unset;
        }
    }

    .stu_card_textarea {
        width: 100%;
        height: 100%;
        padding: 3px;

        /deep/.el-textarea__inner {
            height: 100%;
        }
    }
}

tr {
    mso-height-source: auto;
    mso-ruby-visibility: none;
}

col {
    mso-width-source: auto;
    mso-ruby-visibility: none;
}

br {
    mso-data-placement: same-cell;
}

td {
    mso-style-parent: style0;
    padding-top: 1px;
    padding-right: 1px;
    padding-left: 1px;
    mso-ignore: padding;
    mso-number-format: 'General';
    text-align: general;
    vertical-align: middle;
    white-space: nowrap;
    mso-rotate: 0;
    mso-pattern: auto;
    mso-background-source: auto;
    color: windowtext;
    font-size: 12pt;
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
    font-family: 宋体;
    mso-generic-font-family: auto;
    mso-font-charset: 134;
    border: none;
    mso-protection: locked visible;
}

.xl65 {
    mso-style-parent: style0;
    mso-pattern: auto none;
    background: #ffffff;
    mso-font-charset: 134;
}

.xl66 {
    mso-style-parent: style0;
    mso-pattern: auto none;
    background: #ffffff;
    mso-font-charset: 134;
}

.xl67 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 22pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
}

.xl68 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
}

.xl69 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
}

.xl70 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl71 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl72 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl73 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
}

.xl74 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
}

.xl75 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
}

.xl76 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
}

.xl77 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
}

.xl78 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-right: 0.5pt solid windowtext;
}

.xl79 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl80 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
}

.xl81 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
}

.xl82 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl83 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
}

.xl84 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl85 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl86 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl87 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl88 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl89 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl90 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl91 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border: 0.5pt solid windowtext;
}

.xl92 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl93 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl94 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border: 0.5pt solid windowtext;
}

.xl95 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
}

.xl96 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl97 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
}

.xl98 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
}

.xl99 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl100 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border: 0.5pt solid windowtext;
}

.xl101 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl102 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl103 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl104 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl105 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl106 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl107 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl108 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl109 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl110 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl111 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl112 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
}

.xl113 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl114 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl115 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    mso-font-charset: 134;
}

.xl116 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
}

.xl117 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl118 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border: 0.5pt solid #000000;
}

.xl119 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl120 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl121 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border: 0.5pt solid #000000;
}

.xl122 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
}

.xl123 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl124 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
}

.xl125 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl126 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
}

.xl127 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl128 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    layout-flow: vertical;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl129 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl130 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl131 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl132 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border: 0.5pt solid #000000;
}

.xl133 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl134 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl135 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl136 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl137 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl138 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl139 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl140 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl141 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl142 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl143 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl144 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl145 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl146 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl147 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl148 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl149 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl150 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl151 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl152 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl153 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl154 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 11pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
}

.xl155 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl156 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl157 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl158 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl159 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl160 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl161 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl162 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
}

.xl163 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-top: 0.5pt solid #000000;
}

.xl164 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
}

.xl165 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
}

.xl166 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-right: 0.5pt solid windowtext;
}

.xl167 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-left: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.xl168 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    mso-font-charset: 134;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl169 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl170 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-generic-font-family: swiss;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid windowtext;
}

.xl171 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid #000000;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid windowtext;
}

.xl172 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
}

.xl173 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-top: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
}

.xl174 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid windowtext;
    border-bottom: 0.5pt solid #000000;
}

.xl175 {
    mso-style-parent: style0;
    text-align: center;
    white-space: normal;
    mso-pattern: auto none;
    background: #ffffff;
    font-size: 10pt;
    font-family: Microsoft YaHei;
    mso-font-charset: 134;
    border-left: 0.5pt solid windowtext;
    border-right: 0.5pt solid #000000;
    border-bottom: 0.5pt solid #000000;
}

.grid-content {
    border: 1px solid #000000;
}
</style>
